import { useEffect, useMemo, useRef } from "react";

import { useAppSelector } from "store/index";
import { selectConnectionQuality } from "store/selectors";

/**
 * Hook that determines if the user has a poor connection based on current and previous connection quality.
 */
export const useHasPoorConnection = () => {
  const connectionQuality = useAppSelector(selectConnectionQuality);
  const prevQuality = useRef<"poor" | "good" | "fair">("good");

  const result = useMemo(() => {
    return (
      connectionQuality === "poor" ||
      (connectionQuality === "fair" && prevQuality.current === "poor")
    );
  }, [connectionQuality]);

  useEffect(() => {
    prevQuality.current = connectionQuality;
  }, [connectionQuality]);

  return result;
};
